export default ` Level 3
-=80
K=0
B=0
D=5
P=0
S=0
F=0

xxxxxxxxxxxxxxx
x  --     -- 2x
x x-x-x x-x-x x
x--B        --x
x-x xDx x-xDx-x
xK 1 S S   4--x
x-x x-x x-x x-x
x--F       K--x
x-x-x-x-x-x-x-x
x-------------x
x x-x-x-x-x-x x
x3 ---------  x
xxxxxxxxxxxxxxx`

